import axios from "axios";
import jwtDefaultConfig from "./jwtDefaultConfig";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig };

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false;

  // ** For Refreshing Token
  subscribers = [];

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig };

    // ** Request Interceptor
    axios.interceptors.request.use(
      (config) => {
        // ** Get token from localStorage
        const accessToken = this.getToken();

        // ** If token is present add it to request's Authorization Header
        if (accessToken) {
          // ** eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`;
        }

        const otpToken = this.getOTPToken();
        if (otpToken) {
          config.headers.optcode = `${otpToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error),
    );

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // ** const { config, response: { status } } = error
        const { config, response } = error;
        const originalRequest = config;
        // console.log(response, "the response");
        const isUnauthenticated =
          response &&
          (response.status === 401 ||
            response.data?.message === "Unauthenticated.");

        // ** if (status === 401) {
        if (isUnauthenticated) {
          // ** Check if current page is a public route that should not redirect
          const currentPath = window.location.pathname;
          const publicPaths = [
            "/pages/provider-onboarding",
            "/provider-onboarding/thank-you",
            "/pages/add-refferal-provider",
            "/login",
            "/register",
            "/forgot-password",
            "/new-onboarding",
            // "/otp",
            "/verify-access",
            "/pages/reset-password-cover",
          ];

          // ** Don't redirect if user is on a public page
          const isPublicPage = publicPaths.some((path) =>
            currentPath.startsWith(path),
          );

          if (!isPublicPage) {
            // if (!this.isAlreadyFetchingAccessToken) {
            //   this.isAlreadyFetchingAccessToken = true
            //   this.refreshToken().then(r => {
            //     this.isAlreadyFetchingAccessToken = false
            //     // ** Update accessToken in localStorage
            //     this.setToken(r.data.accessToken)
            //     console.log('Access Token Refreshed!')
            //     this.setRefreshToken(r.data.refreshToken)
            //     this.onAccessTokenFetched(r.data.accessToken)
            //   })
            // }
            // const retryOriginalRequest = new Promise(resolve => {
            //   this.addSubscriber(accessToken => {
            //     // ** Make sure to assign accessToken according to your response.
            //     // ** Check: https://pixinvent.ticksy.com/ticket/2413870
            //     // ** Change Authorization header
            //     originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
            //     resolve(this.axios(originalRequest))
            //   })
            // })
            // return retryOriginalRequest
            localStorage.clear();
            window.location.href = "/login";
          }
          // ** For public pages, just reject the promise without redirecting
          return Promise.reject(error);
        }
        // else if (response && response.status == 409) {
        //      const currentPath = window.location.pathname;

        //   if (currentPath !== "/otp") {
        //   window.location.href = "/otp";
        // }
        // }
        else if (response && response.status == 461) {
          const currentPath = window.location.pathname;

          if (currentPath !== "/renew-password") {
            window.location.href = "/renew-password";
          }
        }
        //  else if (response && response.status == 457) {
        //   window.location.href = "/agreement";
        // }
        else if (response && response.status == 403) {
          window.location.href = "/403";
        }

        // else if (
        //   response &&
        //   [451, 452, 453, 454, 455].includes(response.status)
        // )
        // {
        //   return Promise.reject(error);
        // }

        //  else if (response && response.status == 458) {
        //   window.location.href =
        //     "/dashboard?message=Your Established Roster Already in process.";
        // }
        else if (response && [458, 459, 460].includes(response.status)) {
          // console.log(response?.data?.errors, "response");
          window.location.href = `/dashboard?message=${response?.data?.errors}`;
        }

        if (
          response &&
          [400,451, 452, 453, 454, 455, 457].includes(response.status)
        ) {
          // Just pass it forward
          return Promise.reject({
            ...error,
            onboardingStatus: response.status,
          });
        }

        return Promise.reject(error);
      },
    );
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter((callback) =>
      callback(accessToken),
    );
  }

  addSubscriber(callback) {
    this.subscribers.push(callback);
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName);
  }

  getOTPToken() {
    return localStorage.getItem("otpToken");
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName);
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value);
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value);
  }

  login(...args) {
    return axios.post(`${this.jwtConfig.baseURL}login`, ...args);
  }

  register(...args) {
    return axios.post(`${this.jwtConfig.baseURL}register`, ...args);
  }
  currentUser() {
    return axios.get(`${this.jwtConfig.baseURL}current-user`);
  }
  rolelist() {
    return axios.get(`${this.jwtConfig.baseURL}module/role-list`);
  }
  allModulelist() {
    return axios.get(`${this.jwtConfig.baseURL}module/create-module-list`);
  }
  editRoleModule(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}module/edit-role-modules`,
      ...args,
    );
  }

  storeRoleModule(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}module/store-role-modules`,
      ...args,
    );
  }
  getOnboardingVideoTutorialVideo() {
    return axios.get(`${this.jwtConfig.baseURL}onboarding_video`);
  }
  verifyOtp(...args) {
    return axios.post(`${this.jwtConfig.baseURL}verify-otp`, ...args);
  }

  resendOtp() {
    return axios.post(`${this.jwtConfig.baseURL}regenerate/otp`);
  }

  updateRoleModule(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}module/update-role-modules`,
      ...args,
    );
  }
  deleteRoleModule(id) {
    return axios.delete(`${this.jwtConfig.baseURL}module/destroy-role/${id}`);
  }
  editRoleModulePermissions(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}module/edit-role-module-permission`,
      ...args,
    );
  }

  updateRoleModulePermissions(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}module/update-role-module-permission`,
      ...args,
    );
  }

  siteMapList(...args) {
    return axios.get(`${this.jwtConfig.baseURL}sitemaps/list`, ...args);
  }

  siteMapEdit(...args) {
    return axios.get(`${this.jwtConfig.baseURL}sitemaps/edit`, {
      params: { id: args[0] },
    });
  }
  siteMapUpdate(...args) {
    return axios.post(`${this.jwtConfig.baseURL}sitemaps/update`, ...args);
  }

  siteMapStore(...args) {
    return axios.post(`${this.jwtConfig.baseURL}sitemaps/store`, ...args);
  }
  fetchReceiverEmails(userId) {
    return axios.get(
      `${this.jwtConfig.baseURL}users/${userId}/receiver-emails`,
    );
  }
  storeReceiverEmail(userId, payload) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/${userId}/receiver-emails`,
      payload,
    );
  }
  deleteReceiverEmail(receiverEmailId) {
    return axios.delete(
      `${this.jwtConfig.baseURL}users/receiver-emails/${receiverEmailId}`,
    );
  }
  getallUserlist(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/list`, ...args);
  }
  getSupervisorsList(...args) {
    return axios.get(
      `${this.jwtConfig.baseURL}users/supervisors-list`,
      ...args,
    );
  }
  addThresholdDetails(payload) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/threshold-config/store`,
      payload,
    );
  }
  getCredThresholdDetails(params) {
    return axios.get(`${this.jwtConfig.baseURL}users/threshold-config/show`, {
      params,
    });
  }

  getUserbyID(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/profile`, ...args);
  }
  userRole() {
    return axios.get(`${this.jwtConfig.baseURL}users/create`);
  }

  getProviderUsers() {
    return axios.get(`${this.jwtConfig.baseURL}users/provider-role-users`);
  }

  getEditUser(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/edit`, ...args);
  }

  addUser(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/store`, ...args);
  }

  storePractice(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/store-practice`, ...args);
  }

  updatePracticeRequestStatus(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/practice-requests/update-status`,
      ...args,
    );
  }

  getPracticeRequests(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/practice-requests/list`,
      ...args,
    );
  }

  updateUser(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/update`, ...args);
  }

  providerList() {
    return axios.get(`${this.jwtConfig.baseURL}providers/list`);
  }
  providerAccountManagment() {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/provider-account-management`,
    );
  }
  providerAddEnrolledHistory(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/add-enrolled-history`,
      ...args,
    );
  }
  providerUpdateEnrolledHistory(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/update-enrolled-history`,
      ...args,
    );
  }
  providerDeleteEnrolledHistory(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/delete-enrolled-history`,
      ...args,
    );
  }

  assignedProviderList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/create-assign-provider`,
      ...args,
    );
  }

  unassignedProviderList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/create-unassign-provider`,
      ...args,
    );
  }

  unassignedSaleApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/create-sales-unassign-provider`,
      ...args,
    );
  }

  assignedSaleApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/create-sales-assign-provider`,
      ...args,
    );
  }

  paymentStripStore(...args) {
    return axios.post(`${this.jwtConfig.baseURL}payment/stripe/store`, ...args);
  }

  editUserprofile(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/edit/profile`, ...args);
  }

  updateProfileImage(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/update/profile/image`,
      ...args,
    );
  }

  fetchNpi(...args) {
    return axios.post(`${this.jwtConfig.baseURL}proxy-npi-api`, ...args);
  }

  createProvider() {
    return axios.get(`${this.jwtConfig.baseURL}providers/create`);
  }

  storeProvider(...args) {
    return axios.post(`${this.jwtConfig.baseURL}providers/store`, ...args);
  }

  deleteProvider(...args) {
    return axios.post(`${this.jwtConfig.baseURL}providers/delete`, ...args);
  }
  acknowledgeProviderStatus(...args) {
    console.log(args, "args in jwt service");
    return axios.post(`${this.jwtConfig.baseURL}providers/${args[0].provider_id}/acknowledge`, ...args);
  }
  deletePendingProvider(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/delete-pending-provider`,
      ...args,
    );
  }
  updatePendingProviderStatus(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/update-pending-provider-status`,
      ...args,
    );
  }
  updateProviderStatus(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/update-status`,
      ...args,
    );
  }
  deleteDocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}documents/delete-document`,
      ...args,
    );
  }
  assignOnboardingProvider(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/assign-onboarding-provider`,
      ...args,
    );
  }
  deAssignOnboardingProvider(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/de-assign-onboarding-provider`,
      ...args,
    );
  }

  updateProvider(...args) {
    return axios.post(`${this.jwtConfig.baseURL}providers/update`, ...args);
  }

  storeAssignedCredentialer(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/store-assigned-credentialing`,
      ...args,
    );
  }

  refreshToken() {
    return axios.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    });
  }

  //user
  forgetpassword(...args) {
    return axios.post(`${this.jwtConfig.baseURL}forgot-password`, ...args);
  }
  updatePassword(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/update/password`,
      ...args,
    );
  }
  RenewPassword(...args) {
    return axios.post(`${this.jwtConfig.baseURL}renew/password`, ...args);
  }
  insuranceList() {
    return axios.get(`${this.jwtConfig.baseURL}insurances/list`);
  }
  insuranceListApplication() {
    return axios.get(
      `${this.jwtConfig.baseURL}insurances/insurance-list-application`,
    );
  }
  PackagePriceList() {
    return axios.get(`${this.jwtConfig.baseURL}package-price/list`);
  }

  voucherList() {
    return axios.get(`${this.jwtConfig.baseURL}vouchers`);
  }

  storeVoucher(...args) {
    return axios.post(`${this.jwtConfig.baseURL}vouchers/store`, ...args);
  }
  createPackagePrice() {
    return axios.get(`${this.jwtConfig.baseURL}package-price/create`);
  }

  storePackagePrice(...args) {
    return axios.post(`${this.jwtConfig.baseURL}package-price/store`, ...args);
  }

  createInsurance(...args) {
    return axios.get(`${this.jwtConfig.baseURL}insurances/add`);
  }
  storeInsurance(...args) {
    return axios.post(`${this.jwtConfig.baseURL}insurances/store`, ...args);
  }

  editInsurance(...args) {
    return axios.post(`${this.jwtConfig.baseURL}insurances/edit`, ...args);
  }
  updateInsurance(...args) {
    return axios.post(`${this.jwtConfig.baseURL}insurances/update`, ...args);
  }

  groupSettingList() {
    return axios.get(`${this.jwtConfig.baseURL}groupsettings/list`);
  }

  createGroupSetting(...args) {
    return axios.get(`${this.jwtConfig.baseURL}groupsettings/add`);
  }
  storeGroupSetting(...args) {
    return axios.post(`${this.jwtConfig.baseURL}groupsettings/store`, ...args);
  }

  editGroupSetting(...args) {
    return axios.post(`${this.jwtConfig.baseURL}groupsettings/edit`, ...args);
  }
  updateGroupSetting(...args) {
    return axios.post(`${this.jwtConfig.baseURL}groupsettings/update`, ...args);
  }

  siteMapList() {
    return axios.get(`${this.jwtConfig.baseURL}sitemaps/list`);
  }

  getCardList() {
    return axios.get(`${this.jwtConfig.baseURL}payment/stripe/list`);
  }

  storeSiteMap(...args) {
    return axios.post(`${this.jwtConfig.baseURL}sitemaps/store`, ...args);
  }

  swapProviderPlan(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/provider-plan-insurance/swap`,
      ...args,
    );
  }
  swapProviderPlanPlan(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/provider-plan-plan-insurance/swap`,
      ...args,
    );
  }
  swapGroupPlan(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/group-plan-insurance/swap`,
      ...args,
    );
  }
  swapGroupPlanPlan(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/group-plan-plan-insurance/swap`,
      ...args,
    );
  }
  deleteProviderPlanPlan(id) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/provider-plan-plans/delete`,
      { id: id },
    );
  }
  deleteProviderPlan(id) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/provider-plans/delete`,
      { id: id },
    );
  }
  deleteGroupPlan(id) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/group-plans/delete`,
      { id: id },
    );
  }

  deleteGroupPlanPlan(id) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/group-plan-plans/delete`,
      { id: id },
    );
  }
  updatePlanStatus(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/plan/update-status`,
      ...args,
    );
  }
  deleteTicket(id) {
    return axios.delete(`${this.jwtConfig.baseURL}ticket/${id}`);
  }
  agreementAccept(...args) {
    return axios.post(`${this.jwtConfig.baseURL}save-term-and-policy`, ...args);
  }

  fetchAccountVerificationInformation() {
    return axios.get(`${this.jwtConfig.baseURL}verification-required`);
  }

  storeVerificationDocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}store-verification-document`,
      ...args,
    );
  }

  createNewApplication(validation_request = null) {
    if (validation_request == true) {
      return axios.get(
        `${this.jwtConfig.baseURL}credentialing/new?validation_request=true`,
      );
    }
    return axios.get(`${this.jwtConfig.baseURL}credentialing/new`);
  }

  createEstablishedApplication() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/establish-application`,
    );
  }

  viewApplications(...args) {
    return axios.post(`${this.jwtConfig.baseURL}credentialing/view`, ...args);
  }
  storeNewApplication(...args) {
    return axios.post(`${this.jwtConfig.baseURL}credentialing/new`, ...args);
  }

  createReport(...args) {
    return axios.post(`${this.jwtConfig.baseURL}reports/list`, ...args);
  }
  customRequestReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/custom-request-report`,
      ...args,
    );
  }
  exclusionsRequestReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/exclusions-request-report`,
      ...args,
    );
  }
  efficiencyRequestReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/efficiency-request-report`,
      ...args,
    );
  }
  teamRequestReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/team-request-report`,
      ...args,
    );
  }

  downloadPdfReport(...args) {
    return axios.post(`${this.jwtConfig.baseURL}reports/download/pdf`, ...args);
  }
  downloadPdfReportforCustom(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/custom`,
      ...args,
    );
  }
  downloadPdfReportforExclusion(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/exclusion`,
      ...args,
    );
  }
  downloadPdfReportforEfficiency(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/efficiency-pdf`,
      ...args,
    );
  }
  downloadExcelReportforEfficiency(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/efficiency-excel`,
      ...args,
    );
  }
  downloadInsuranceGridReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/insurance-grid`,
      ...args,
    );
  }
  downloadCsvPracticeProviders(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/download-csv-providers`,
      ...args,
    );
  }

  downloadProvidersdetailsPdf(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/download-provider-details`,
      ...args,
    );
  }

  downloadPreCredentialingPdfReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/pre-credentialing-pdf`,
      ...args,
    );
  }

  downloadAllPreCredentialingPdfReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/all-pre-credentialing-pdf`,
      ...args,
    );
  }

  downloadPreCredentialingExcelReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/pre-credentialing-excel`,
      ...args,
    );
  }

  downloadAllPreCredentialingExcelReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/all-pre-credentialing-excel`,
      ...args,
    );
  }

  downloadPdfInvoice(data) {
    return axios.post(
      `${this.jwtConfig.baseURL}invoices/download-invoice`,
      data,
    );
  }
  downloadInvoiceExcelReport(data) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/invoice-excel-report`,
      data,
    );
  }
  exportInsurance(data) {
    return axios.post(`${this.jwtConfig.baseURL}insurances/export`, {
      data,
    });
  }
  changeInvoiceStatus(data) {
    return axios.post(
      `${this.jwtConfig.baseURL}invoices/change-invoice-status`,
      data,
    );
  }
  deleteInvoice(data) {
    return axios.post(`${this.jwtConfig.baseURL}invoices/delete-invoice`, data);
  }
  deleteProviderReferralRecipient(id) {
    console.log(id, "id in jwt service");
    return axios.post(
      `${this.jwtConfig.baseURL}providers/refferal-link/delete`,
      id,
    );
  }
  deleteDocumentLinks(id) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/document-link/delete`,
      { id: id },
    );
  }
  downloadExcelReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/download/excel`,
      ...args,
    );
  }

  fetchInvoice(...args) {
    return axios.post(`${this.jwtConfig.baseURL}invoices/show`, ...args);
  }
  fetchStateInsurance(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}invoices/fetch-state-insurance`,
      ...args,
    );
  }
  storeInsurancePlans(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}invoices/store-insurance-plans`,
      ...args,
    );
  }

  // fetchApplicationList(user_id = null,color=null) {
  //   const url = user_id?.user_id_param
  //     ? `${this.jwtConfig.baseURL}credentialing/applications/list?user_id=${user_id.user_id_param}`
  //     : `${this.jwtConfig.baseURL}credentialing/applications/list`;

  //   return axios.get(url);
  // }

  // fetchApplicationList(user_id = null, color = null) {
  //   let url = `${this.jwtConfig.baseURL}credentialing/applications/list`;
  //   const params = new URLSearchParams();

  //   if (user_id?.user_id_param) {
  //     params.append("user_id", user_id.user_id_param);
  //   }

  //   if (color?.color) {
  //     params.append("color", color.color);
  //   }

  //   const queryString = params.toString();
  //   if (queryString) {
  //     url += `?${queryString}`;
  //   }

  //   return axios.get(url);
  // }

  fetchApplicationList(params = {}) {
    let url = `${this.jwtConfig.baseURL}credentialing/applications/list`;
    const urlParams = new URLSearchParams();

    // Add all parameters that have values
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined) {
        urlParams.append(key, params[key]);
      }
    });

    const queryString = urlParams.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return axios.get(url);
  }

  fetchPaymentInfoList(...args) {
    return axios.post(`${this.jwtConfig.baseURL}payment/payment-info`, ...args);
  }

  storeFtpGroupRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-group-activity/store-remarks`,
      ...args,
    );
  }

  fetchFtpEftList(id) {
    return axios.get(`${this.jwtConfig.baseURL}ftp-eft/list-remarks/${id}`);
  }

  fetchFtpEdiList(id) {
    return axios.get(`${this.jwtConfig.baseURL}ftp-edi/list-remarks/${id}`);
  }

  fetchFtpLicenseList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-licensing-signup/list-remarks`,
      ...args,
    );
  }

  storeFtpEftMessage(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-eft/store-message`,
      ...args,
    );
  }

  storeFtpLicenseMessage(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-licensing-signup/store-message`,
      ...args,
    );
  }

  storeFtpEdiMessage(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-edi/store-message`,
      ...args,
    );
  }

  fetchFtpEdiMessages(...args) {
    return axios.post(`${this.jwtConfig.baseURL}ftp-edi/list-message`, ...args);
  }

  fetchFtpEftMessages(...args) {
    return axios.post(`${this.jwtConfig.baseURL}ftp-eft/list-message`, ...args);
  }

  fetchFtpLicenseMessages(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-licensing-signup/list-messages`,
      ...args,
    );
  }
  ftpGroupStoredocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-group-activity/store-document`,
      ...args,
    );
  }

  ftpEdiStoredocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-edi/store-document`,
      ...args,
    );
  }

  ftpEftStoredocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-eft/store-document`,
      ...args,
    );
  }

  ftpProviderStoredocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-activity/store-document`,
      ...args,
    );
  }

  ftplicenseStoredocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-licensing-signup/store-document`,
      ...args,
    );
  }

  updateFtpGroupRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-group-activity/update-remarks`,
      ...args,
    );
  }

  storeFtpProviderRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-activity/store-remarks`,
      ...args,
    );
  }

  storeFtpEditRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-group-activity/edit-remarks`,
      ...args,
    );
  }
  storeFtpDeleteRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-group-activity/delete-remarks`,
      ...args,
    );
  }

  ediFtpDeleteRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-edi/delete-remarks`,
      ...args,
    );
  }

  eftFtpDeleteRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-eft/delete-remarks`,
      ...args,
    );
  }

  storeFtpProviderEditRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-activity/edit-remarks`,
      ...args,
    );
  }
  storeFtpProviderDeleteRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-activity/delete-remarks`,
      ...args,
    );
  }

  updateFtpProviderRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-activity/update-remarks`,
      ...args,
    );
  }

  //ftp eft
  storeFtpEftRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-eft/store-remarks`,
      ...args,
    );
  }

  storeFtpEdiRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-edi/store-remarks`,
      ...args,
    );
  }

  updateFtpEdiRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-edi/update-remarks`,
      ...args,
    );
  }

  updateFtpeftRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-eft/update-remarks`,
      ...args,
    );
  }

  storeFtpLicenseRemarks(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-licensing-signup/store-remarks`,
      ...args,
    );
  }

  fetchFtpGroupList(id) {
    return axios.get(`${this.jwtConfig.baseURL}ftp-group-activity/list/${id}`);
  }

  fetchFtpProviderList(id) {
    return axios.get(
      `${this.jwtConfig.baseURL}ftp-activity/list-remarks/${id}`,
    );
  }

  createCustomRequestList() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/custom-request`,
    );
  }

  storeCustomRequestList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/custom-request/store`,
      ...args,
    );
  }

  createLicensingandSignupList() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/licensing-and-signup`,
    );
  }

  editProviderApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/providerplans/edit`,
      ...args,
    );
  }

  editLicenseApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/licensing-and-signup/edit`,
      ...args,
    );
  }

  editEdiApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/edi/edit`,
      ...args,
    );
  }

  updateEdiApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/edi/update`,
      ...args,
    );
  }

  editGroupApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/groupplans/edit`,
      ...args,
    );
  }

  editProviderApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/providerplans/edit`,
      ...args,
    );
  }

  editMainGroupApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/groupplans/edit-main-application`,
      ...args,
    );
  }

  updateMainGroupApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/groupplans/update-main-application`,
      ...args,
    );
  }

  editMainProviderApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/providerplans/edit-main-application`,
      ...args,
    );
  }

  updateMainProviderApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/providerplans/update-main-application`,
      ...args,
    );
  }

  updateProviderApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/providerplans/update`,
      ...args,
    );
  }

  updateLicenseApplicationList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/licensing-and-signup/update`,
      ...args,
    );
  }

  createEdiList() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/edi/create`,
    );
  }

  createExclusionList() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/exclusions/create`,
    );
  }

  createEftDepositeList() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/eft-deposite/create`,
    );
  }

  storeEstablishedApplication(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/established-applications/upload`,
      ...args,
    );
  }

  storeEstablishedApplicationManullay(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/store-establish-application`,
      ...args,
    );
  }

  storeExclusionApplication(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/exclusions/store`,
      ...args,
    );
  }

  updateOwnProfile(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/update/profile`, ...args);
  }

  paidInvoiceList() {
    return axios.get(`${this.jwtConfig.baseURL}invoices/paid-list`);
  }

  pendingInvoiceList() {
    return axios.get(`${this.jwtConfig.baseURL}invoices/pending-list`);
  }

  editProvider(...args) {
    return axios.post(`${this.jwtConfig.baseURL}providers/edit`, ...args);
  }

  viewProvider(...args) {
    return axios.post(`${this.jwtConfig.baseURL}providers/show`, ...args);
  }

  saveCrsUser(...args) {
    return axios.post(`${this.jwtConfig.baseURL}crs/store-crs-user`, ...args);
  }

  listCrsUser(...args) {
    return axios.get(`${this.jwtConfig.baseURL}crs/list-crs-user`, ...args);
  }

  UpdateCrsUser(...args) {
    return axios.post(`${this.jwtConfig.baseURL}crs/update-crs-user`, ...args);
  }

  editCrsUser(...args) {
    return axios.post(`${this.jwtConfig.baseURL}crs/edit-crs-user`, ...args);
  }

  dashboard(filterParams = {}) {
    return axios.get(`${this.jwtConfig.baseURL}dashboard`, {
      params: filterParams, // This sends them as query parameters
    });
  }

  centralDashboard(filterParams = {}) {
    return axios.get(`${this.jwtConfig.baseURL}dashboard/central`, {
      params: filterParams,
    });
  }

  // filterData(filterParams) {
  //   return axios.get(`${this.jwtConfig.baseURL}dashboard`, filterParams);
  // }
  updateGroupSetting(...args) {
    return axios.post(`${this.jwtConfig.baseURL}groupsettings/update`, ...args);
  }
  documentList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}documents/list-document`,
      ...args,
    );
  }

  /**
   * Request server to create a ZIP from stored files and return as blob
   * Payload expected to be an object, e.g. { files: [ 'url1', 'url2' ] }
   */
  zipFromStorage(payload) {
    // Request raw binary ArrayBuffer to avoid any intermediate encoding/truncation
    return axios.post(`${this.jwtConfig.baseURL}zip-from-storage`, payload);
  }

  storeEdi(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/edi/store`,
      ...args,
    );
  }

  storeEftBankAccount(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/eft-deposite/store-eft-bankaccount`,
      ...args,
    );
  }

  updatePassword(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/update/password`,
      ...args,
    );
  }
  RenewPassword(...args) {
    return axios.post(`${this.jwtConfig.baseURL}renew/password`, ...args);
  }

  //ftp group

  storeFtpGroupMessages(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-group-activity/store-message`,
      ...args,
    );
  }

  fetchFtpGroupMessages(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-group-activity/list-message`,
      ...args,
    );
  }

  //ftp-provider
  storeFtpProviderMessages(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-activity/store-message`,
      ...args,
    );
  }

  fetchFtpProviderMessages(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}ftp-activity/list-message`,
      ...args,
    );
  }

  payThroughDefaultCard(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}payment/stripe/pay-through-default-card`,
      ...args,
    );
  }

  payForSubscription(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}payment/stripe/pay-for-subscription`,
      ...args,
    );
  }

  setDefaultCard(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}payment/stripe/defaultmethod`,
      ...args,
    );
  }

  deleteCard(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}payment/stripe/delete`,
      ...args,
    );
  }

  readAllNotification() {
    return axios.get(`${this.jwtConfig.baseURL}notifications/all`);
  }
  getCardDetails() {
    return axios.get(`${this.jwtConfig.baseURL}payment/get-card-details`);
  }

  markAsRead(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}notifications/mark-as-read`,
      ...args,
    );
  }

  markAllAsRead() {
    return axios.post(
      `${this.jwtConfig.baseURL}notifications/mark-all-as-read`,
    );
  }

  deleteNotification(id) {
    return axios.post(`${this.jwtConfig.baseURL}notifications/delete/${id}`);
  }

  blogList() {
    return axios.get(`${this.jwtConfig.baseURL}blogs/list`);
  }

  blogStore(...args) {
    return axios.post(`${this.jwtConfig.baseURL}blogs/store`, ...args);
  }

  blogEdit(...args) {
    return axios.get(`${this.jwtConfig.baseURL}blogs/edit`, {
      params: { id: args[0] },
    });
  }

  blogUpdate(...args) {
    return axios.post(`${this.jwtConfig.baseURL}blogs/update`, ...args);
  }

  blogEdit(...args) {
    return axios.get(`${this.jwtConfig.baseURL}blogs/edit`, {
      params: { id: args[0] },
    });
  }

  blogStatus(...args) {
    return axios.post(`${this.jwtConfig.baseURL}blogs/status`, ...args);
  }

  blogDelete(...args) {
    return axios.post(`${this.jwtConfig.baseURL}blogs/delete`, ...args);
  }

  // Subscription Prices API Methods
  subscriptionPricesList() {
    return axios.get(`${this.jwtConfig.baseURL}subscription-prices/list`);
  }

  subscriptionPricesStore(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}subscription-prices/store`,
      ...args,
    );
  }

  subscriptionPricesEdit(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}subscription-prices/edit`,
      ...args,
    );
  }

  subscriptionPricesUpdate(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}subscription-prices/update`,
      ...args,
    );
  }

  subscriptionPricesDelete(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}subscription-prices/delete`,
      ...args,
    );
  }

  subscriptionPricesStatus(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}subscription-prices/status`,
      ...args,
    );
  }

  storeEft(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/eft-deposite/store`,
      ...args,
    );
  }

  createEstablished(...args) {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/established-applications/create`,
      ...args,
    );
  }

  toggleProviderVerification(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/toggle-provider-verification`,
      ...args,
    );
  }

  loginAs(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/login-as`, ...args);
  }

  googleLogin(...args) {
    return axios.post(`${this.jwtConfig.baseURL}auth/google/callback`, ...args);
  }

  resetAccount(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/reset`, ...args);
  }

  deleteAccount(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/delete-user`, ...args);
  }

  getUserDeactivationReasons(...args) {
    return axios.get(
      `${this.jwtConfig.baseURL}get-user-deactivate-reasons`,
      ...args,
    );
  }

  deActivateAccountRequest(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}deactivate-account-request`,
      ...args,
    );
  }

  getDeactivateRequests(...args) {
    return axios.get(
      `${this.jwtConfig.baseURL}users/deactivate-requests`,
      ...args,
    );
  }
  updateConsents(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/update-consents`,
      ...args,
    );
  }
  getUserConsents(...args) {
    return axios.get(`${this.jwtConfig.baseURL}users/consents`, ...args);
  }

  deactivateAccount(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/deactivate-account`,
      ...args,
    );
  }

  resetEnterpriseAccount(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/reset-enterprise-account`,
      ...args,
    );
  }

  ShowToaster(message) {
    toast(
      <div className="d-flex">
        <div className="me-1">
          <Avatar size="sm" color="success" icon={<Check size={12} />} />
        </div>
        <div className="d-flex flex-column">
          <h6>{message}</h6>
        </div>
      </div>,
    );
  }

  updatePaymentStatus(...args) {
    return axios.post(`${this.jwtConfig.baseURL}payment/pay-offline`, ...args);
  }

  generatStripeLink(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}payment/generate-stripe-link`,
      ...args,
    );
  }

  sendQrCodeViaEmail(...args) {
    return axios.post(`${this.jwtConfig.baseURL}send-qr-code-email`, ...args);
  }

  sendQrCodeViaScreen(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}send-qr-code-notification`,
      ...args,
    );
  }

  showZelleQrCodeonScreen(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}show-zelle-qr-code-on-screen`,
      ...args,
    );
  }

  hideZelleQrCodeonScreen(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}hide-zelle-qr-code-on-screen`,
      ...args,
    );
  }

  updateGroupApplication(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/groupplans/update`,
      ...args,
    );
  }

  updateProviderApplication(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/providerplans/update`,
      ...args,
    );
  }

  handleSendQrCodeToUserScreen(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}send-qr-code-notification`,
      ...args,
    );
  }

  handleSendQrCodeToUserEmail(...args) {
    return axios.post(`${this.jwtConfig.baseURL}send-qr-code-email`, ...args);
  }
  createdocument() {
    return axios.get(`${this.jwtConfig.baseURL}documents/doc-for`);
  }

  storeDocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}documents/store-document`,
      ...args,
    );
  }

  fetchStates() {
    return axios.get(`${this.jwtConfig.baseURL}states-list`);
  }

  editEftOption(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/eft-deposite/edit`,
      ...args,
    );
  }

  editCustomRequest(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/custom-request/edit`,
      ...args,
    );
  }

  updateEftOption(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/eft-deposite/update`,
      ...args,
    );
  }

  updateCustomRequest(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/custom-request/update`,
      ...args,
    );
  }

  editExclusion(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/exclusions/edit`,
      ...args,
    );
  }

  updateExclusion(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/exclusions/update`,
      ...args,
    );
  }

  storeRemarkExclusion(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/exclusions/remarks/store`,
      ...args,
    );
  }

  storeRemarkCustomRequest(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/custom-request/remarks/store`,
      ...args,
    );
  }

  fetchRemarkExclusion(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/exclusions/remarks`,
      ...args,
    );
  }

  fetchRemarkCustomRequest(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/custom-request/remarks`,
      ...args,
    );
  }

  storeLicenseAndSignup(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/licensing-and-signup/store`,
      ...args,
    );
  }

  assignedProvider() {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/show-assigned-providers`,
    );
  }
  unAssignedProvider() {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/show-unassigned-providers`,
    );
  }
  assignedPracticesList() {
    return axios.get(`${this.jwtConfig.baseURL}users/assigned-practices-list`);
  }
  unAssignedPracticesList() {
    return axios.get(
      `${this.jwtConfig.baseURL}users/unassigned-practices-list`,
    );
  }
  unAssignPractices(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/unassign-practices`,
      ...args,
    );
  }
  assignPractices(payload) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/assign-practices`,
      payload,
    );
  }
  onBoardingProvider() {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/show-onboarding-providers`,
    );
  }
  onBoardingPendingProviders() {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/show-onboarding-pending-providers`,
    );
  }

  storeAssignedProviderList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/assign-provider`,
      ...args,
    );
  }

  storeAssignedSaleList(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/assign-sales-provider`,
      ...args,
    );
  }

  deleteAssignedSaleApplication(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/de-assign-sales-provider`,
      ...args,
    );
  }

  deleteAssignedProviderApplication(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/de-assign-provider`,
      ...args,
    );
  }

  storeImportRoster(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/established-applications/store`,
      ...args,
    );
  }

  accountSettings(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/account-settings`,
      ...args,
    );
  }
  oigFilters(...args) {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/oig-exclusions-filters`,
      ...args,
    );
  }
  oigList(params) {
    return axios.get(`${this.jwtConfig.baseURL}providers/oig-exclusions`, {
      params,
    });
  }
  oigSearch(params) {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/oig-exclusions/search`,
      { params },
    );
  }

  // crs
  crsAdditionalAmount(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}crs/store-additional-amount-crm`,
      ...args,
    );
  }

  getcommissionlink(...args) {
    return axios.post(`${this.jwtConfig.baseURL}crs/store-crm-link`, ...args);
  }

  sendReferralEmail(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}crs/send-referral-email`,
      ...args,
    );
  }

  fetchLeads() {
    return axios.get(`${this.jwtConfig.baseURL}crs/leads-index`);
  }

  updateUserSettingbyCrs(...args) {
    return axios.post(`${this.jwtConfig.baseURL}crs/lead-update`, ...args);
  }

  updateReferRecord(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}crs/update-referrer-record`,
      ...args,
    );
  }

  getRerralLinkByProvider(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}refer-by-provider/generate-link`,
      ...args,
    );
  }

  resetPassword(...args) {
    return axios.post(`${this.jwtConfig.baseURL}reset-password`, ...args);
  }

  storeValidationDocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/store-validation-document`,
      ...args,
    );
  }

  createUserSpeciality() {
    return axios.get(`${this.jwtConfig.baseURL}other-request-speciality`);
  }

  approveUserSpeciality(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}request-speciality/store`,
      ...args,
    );
  }

  createProviderSpeciality() {
    return axios.get(
      `${this.jwtConfig.baseURL}other-provider-request-speciality`,
    );
  }

  approveProviderSpeciality(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}provider-request-speciality/store`,
      ...args,
    );
  }

  requestForPermissions(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/request-for-permissions`,
      ...args,
    );
  }

  getUserReferralAmount() {
    return axios.get(
      `${this.jwtConfig.baseURL}refer-by-provider/get-referral-amount`,
    );
  }

  grantAccess(data) {
    return axios.get(
      `${this.jwtConfig.baseURL}users/grant-access?token=${data.token}&id=${data.id}`,
    );
  }

  logout() {
    const rand_string = localStorage.getItem("rand_string");
    const url = `${this.jwtConfig.baseURL}logout${
      rand_string ? `?rand_string=${rand_string}` : ""
    }`;
    return axios.post(url);
  }

  countUnsignedApplications() {
    return axios.get(`${this.jwtConfig.baseURL}count-unsigned-applications`);
  }

  getMailtrapSettings() {
    return axios.get(`${this.jwtConfig.baseURL}mail/mailtrap-settings`);
  }

  updateMailtrapSettings(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}mail/mailtrap-settings`,
      ...args,
    );
  }

  toogleAccountActivation(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/toggle-account-activation`,
      ...args,
    );
  }

  processBulkPayment(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}payment/process-bulk-payment`,
      ...args,
    );
  }

  leaveEnterprise(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/enterprise/leave`,
      ...args,
    );
  }

  ConfirmleaveEnterprise(token) {
    return axios.get(
      `${this.jwtConfig.baseURL}users/enterprise/leave-confirm/${token}`,
    );
  }

  alertsList() {
    return axios.get(`${this.jwtConfig.baseURL}alerts`);
  }

  alertscreate() {
    return axios.get(`${this.jwtConfig.baseURL}alerts/create`);
  }

  alertStore(...args) {
    return axios.post(`${this.jwtConfig.baseURL}alerts/store`, ...args);
  }

  editAlert(id) {
    return axios.get(`${this.jwtConfig.baseURL}alerts/edit/${id}`);
  }

  updateAlert(...args) {
    return axios.post(`${this.jwtConfig.baseURL}alerts/update`, ...args);
  }

  usefulresourceList() {
    return axios.get(`${this.jwtConfig.baseURL}useful-resources`);
  }

  usefulresourceCreate() {
    return axios.get(`${this.jwtConfig.baseURL}useful-resources/create`);
  }

  usefulresourceStore(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}useful-resources/store`,
      ...args,
    );
  }

  usefulresourceEdit(id) {
    return axios.get(`${this.jwtConfig.baseURL}useful-resources/edit/${id}`);
  }

  updateusefulresource(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}useful-resources/update`,
      ...args,
    );
  }

  // add comment
  EnrollmentValidationStoreComments(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/store-comment`,
      ...args,
    );
  }

  EnrollmentValidationListComments(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/list-comment`,
      ...args,
    );
  }

  fetchPreCredentialingApplications(...args) {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/list`,
      ...args,
    );
  }
  fetchInternalDashboardReport(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}reports/internal-team-report`,
      ...args,
    );
  }
  preCredentialing(...args) {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/create`,
      ...args,
    );
  }
  storePreCredentialing(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/store`,
      ...args,
    );
  }
  updatePayerDetail(payerDetailId, payload) {
    return axios.patch(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/payer-details/${payerDetailId}`,
      payload,
    );
  }
  fetchPlanRemarks(planDetailId) {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/plan-details/${planDetailId}/remarks`,
    );
  }
  storePlanRemark(planDetailId, payload) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/plan-details/${planDetailId}/remarks`,
      payload,
    );
  }
  updatePlanDetail(planDetailId, payload) {
    return axios.patch(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/plan-details/${planDetailId}`,
      payload,
    );
  }
  fetchLicensingRemarks(licensingDetailId) {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/licensing-details/${licensingDetailId}/remarks`,
    );
  }
  storeLicensingRemark(licensingDetailId, payload) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/licensing-details/${licensingDetailId}/remarks`,
      payload,
    );
  }
  updateLicensingDetail(licensingDetailId, payload) {
    return axios.patch(
      `${this.jwtConfig.baseURL}credentialing/applications/pre-credentialing/licensing-details/${licensingDetailId}`,
      payload,
    );
  }
  LicensingSignupStoreComments(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/licensing-and-signup/store-comment`,
      ...args,
    );
  }

  LicensingSignupListComments(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/licensing-and-signup/list-comment`,
      ...args,
    );
  }

  UpcomingDeadlines() {
    return axios.post(`${this.jwtConfig.baseURL}reports/termination-deadlines`);
  }

  providerImportExcel(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/store-provider-excel`,
      ...args,
    );
  }
  usefulresourcelist() {
    return axios.get(`${this.jwtConfig.baseURL}useful-resources-list`);
  }

  downloadProviderSample() {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/download-provider-sample`,
      {
        responseType: "blob", // ⚡ important
      },
    );
  }

  // Ticket-related methods
  getTicketsMetadata() {
    return axios.get(`${this.jwtConfig.baseURL}tickets/metadata`);
  }

  getUserPermissions() {
    return axios.get(`${this.jwtConfig.baseURL}tickets/user-permissions`);
  }

  getTickets(params = {}) {
    return axios.get(`${this.jwtConfig.baseURL}tickets`, { params });
  }

  getTicket(id) {
    return axios.get(`${this.jwtConfig.baseURL}tickets/${id}`);
  }

  createTicket(formData) {
    // For demo purposes, log the form data to see what's being sent
    console.log("Creating ticket with data:", formData);
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    return axios.post(`${this.jwtConfig.baseURL}tickets`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  updateTicket(id, data) {
    return axios.put(`${this.jwtConfig.baseURL}tickets/${id}`, data);
  }

  deleteTicket(id) {
    return axios.delete(`${this.jwtConfig.baseURL}tickets/${id}`);
  }

  addTicketComment(ticketId, formData) {
    return axios.post(
      `${this.jwtConfig.baseURL}tickets/${ticketId}/comments`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  }

  updateTicketComment(ticketId, commentId, data) {
    return axios.put(
      `${this.jwtConfig.baseURL}tickets/${ticketId}/comments/${commentId}`,
      data,
    );
  }

  deleteTicketComment(ticketId, commentId) {
    return axios.delete(
      `${this.jwtConfig.baseURL}tickets/${ticketId}/comments/${commentId}`,
    );
  }

  updateTicketStatus(id, statusId) {
    return axios.put(`${this.jwtConfig.baseURL}tickets/${id}`, {
      ticket_status_id: statusId,
    });
  }

  updateTicketAssignment(id, assignedTo) {
    return axios.put(`${this.jwtConfig.baseURL}tickets/${id}`, {
      assigned_to: assignedTo,
    });
  }

  downloadTicketAttachment(ticketId, attachmentId) {
    return axios.get(
      `${this.jwtConfig.baseURL}tickets/${ticketId}/attachments/${attachmentId}/download`,
      {
        responseType: "blob",
      },
    );
  }

  getClosedTickets() {
    // For now, return mock data until backend is fully implemented
    return Promise.resolve({
      data: {
        success: true,
        data: [
          {
            id: 1,
            ticket_number: "TKT10001",
            title: "Previous billing issue",
            closed_at: "2024-09-25T10:30:00Z",
            category: { name: "Billing" },
            user: { first_name: "John", last_name: "Doe" },
          },
          {
            id: 2,
            ticket_number: "SCR10002",
            title: "Credentialing request follow-up",
            closed_at: "2024-09-20T14:15:00Z",
            category: { name: "Credentialing" },
            user: { first_name: "Jane", last_name: "Smith" },
          },
        ],
      },
    });
    // Uncomment when backend is ready:
    // return axios.get(`${this.jwtConfig.baseURL}tickets/closed-tickets`);
  }

  // Feedback-related methods
  getFeedbackMetadata() {
    return axios.get(`${this.jwtConfig.baseURL}feedback/metadata`);
  }

  getFeedback(params = {}) {
    return axios.get(`${this.jwtConfig.baseURL}feedback`, { params });
  }

  getFeedbackById(id) {
    return axios.get(`${this.jwtConfig.baseURL}feedback/${id}`);
  }

  createFeedback(data) {
    return axios.post(`${this.jwtConfig.baseURL}feedback`, data);
  }

  updateFeedback(id, data) {
    return axios.put(`${this.jwtConfig.baseURL}feedback/${id}`, data);
  }

  deleteFeedback(id) {
    return axios.delete(`${this.jwtConfig.baseURL}feedback/${id}`);
  }

  createRefferalProvider(params = {}) {
    return axios.get(`${this.jwtConfig.baseURL}create-referral-provider`, {
      params,
    });
  }

  storeRefferalProvider(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}store-referral-provider`,
      ...args,
    );
  }

  sendProviderReferralLink(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/send-provider-referral-link`,
      ...args,
    );
  }

  resendProviderReferralEmail(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/resend-provider-referral-email`,
      ...args,
    );
  }

  resendProviderShareDocumentEmail(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/resend-send-share-document-link`,
      ...args,
    );
  }

  getProviderReferralRecipients(params = {}) {
    return axios.get(`${this.jwtConfig.baseURL}providers/referral-recipients`, {
      params,
    });
  }

  getProviderReferralRecipient(id) {
    return axios.get(
      `${this.jwtConfig.baseURL}providers/referral-recipients/${id}`,
    );
  }

  updateRecipientStatus(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/referral-recipient/update-status`,
      ...args,
    );
  }

  // ** Pricing API Methods
  getPricingInfo() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/pricing/info`,
    );
  }

  calculatePrice(data) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/pricing/calculate`,
      data,
    );
  }

  checkApplicationLimit(data) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/pricing/check-limit`,
      data,
    );
  }

  getSubscriptionStatus() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/pricing/subscription-status`,
    );
  }

  getApplicationHistory() {
    return axios.get(
      `${this.jwtConfig.baseURL}credentialing/applications/pricing/application-history`,
    );
  }

  validateProviderPlans(data) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/pricing/validate-provider-plans`,
      data,
    );
  }

  // Provider Onboarding
  submitProviderOnboarding(data) {
    return axios.post(`${this.jwtConfig.baseURL}provider-onboarding`, data);
  }

  downloadProviderOnboardingPdf(id) {
    return axios.get(`${this.jwtConfig.baseURL}provider-onboarding/${id}/pdf`);
  }

  getProviderOnboardingAttachments(id) {
    return axios.get(
      `${this.jwtConfig.baseURL}provider-onboarding/${id}/attachments`,
    );
  }

  deleteEstablishedApplication(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/delete-establish-application`,
      ...args,
    );
  }
  deleteEFTCard(id) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/eft-card/delete`,
      { id: id },
    );
  }
  shareDocumentLink(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/share-provider-document-link`,
      ...args,
    );
  }

  getTokenInformation(token) {
    return axios.get(`${this.jwtConfig.baseURL}get-share-link-info/${token}`);
  }

  storeShareLinkProviderDocument(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}share-provider-document-link`,
      ...args,
    );
  }

  providerAddedViaLink(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/provider-added-via-link`,
      ...args,
    );
  }

  changeStatusToInProgress(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}change-status-to-inprogress`,
      ...args,
    );
  }

  VerifyRoster(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}credentialing/applications/established-applications/verify-roaster`,
      ...args,
    );
  }

  PermissionList() {
    return axios.get(`${this.jwtConfig.baseURL}permissions/list`);
  }

  getModulesAndPermissions() {
    return axios.get(`${this.jwtConfig.baseURL}permissions/create`);
  }

  storePermission(...args) {
    return axios.post(`${this.jwtConfig.baseURL}permissions/store`, ...args);
  }

  fetchEditPermission(id) {
    return axios.get(`${this.jwtConfig.baseURL}permissions/edit/${id}`);
  }

  updatePermission(...args) {
    return axios.post(`${this.jwtConfig.baseURL}permissions/update`, ...args);
  }
  getuserlocation(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/get-user-location`,
      ...args,
    );
  }

  fetchAssignAddresses(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/location-manager-location`,
      ...args,
    );
  }
  fetchWalletAmount(id) {
    return axios.get(
      `${this.jwtConfig.baseURL}users/fetch-wallet-amount/${id}`,
    );
  }
  updateWalletAmount(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/update-wallet-amount`,
      ...args,
    );
  }

  updateAddress(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/update-user-locations`,
      ...args,
    );
  }

  deleteManagerLocation(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/delete-location-manager`,
      ...args,
    );
  }

  getAllPendingusers(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/pending-users`, ...args);
  }

  addComment(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/add-pending-user-comment`,
      ...args,
    );
  }

  getComments(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}users/pending-user-comment`,
      ...args,
    );
  }
  getProviderLicenseDetails(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/get-license-details`,
      ...args,
    );
  }
  addLicenseDetails(...args) {
    return axios.post(
      `${this.jwtConfig.baseURL}providers/add-license-details`,
      ...args,
    );
  }

  dashboardNews(filterParams = {}) {
    return axios.get(`${this.jwtConfig.baseURL}dashboard/news`, {
      params: filterParams,
    });
  }

  dashboardNewsItem(id) {
    return axios.get(`${this.jwtConfig.baseURL}dashboard/news/${id}`);
  }
  userStatus() {
    return axios.get(`${this.jwtConfig.baseURL}user/status`);
  }
  userUpdate(...args) {
    return axios.post(`${this.jwtConfig.baseURL}users/update`, ...args);
  }
  downloadUserListExcel(params) {
    return axios.get(
      `${this.jwtConfig.baseURL}users/download-user-list-excel`,
      { params },
    );
  }
  downloadPendingUserListExcel(params) {
    return axios.get(
      `${this.jwtConfig.baseURL}users/download-pending-user-list-excel`,
      { params },
    );
  }
  // Client Onboarding
  createClientOnboarding() {
    return axios.post(`${this.jwtConfig.baseURL}client-onboarding/create`);
  }

  getClientOnboarding() {
    return axios.get(`${this.jwtConfig.baseURL}client-onboarding`);
  }

  getClientOnboardingList(params) {
    return axios.get(`${this.jwtConfig.baseURL}client-onboarding/list`, {
      params,
    });
  }

  getClientOnboardingById(id) {
    return axios.get(`${this.jwtConfig.baseURL}client-onboarding/${id}`);
  }

  saveClientOnboardingStep(stepNumber, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/step-${stepNumber}`,
      data,
    );
  }

  deleteClientOnboarding(id) {
    return axios.delete(`${this.jwtConfig.baseURL}client-onboarding/${id}`);
  }

  // Client Onboarding – Comments
  getClientOnboardingComments(id, step) {
    return axios.get(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/comments`,
      { params: { step } },
    );
  }

  addClientOnboardingComment(id, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/comments`,
      data,
    );
  }

  // Client Onboarding – Attachments
  getClientOnboardingAttachments(id, step) {
    return axios.get(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/attachments`,
      { params: { step } },
    );
  }

  uploadClientOnboardingAttachment(id, formData) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/attachments`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  }

  deleteClientOnboardingAttachment(id, attachmentId) {
    return axios.delete(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/attachments/${attachmentId}`,
    );
  }

  downloadClientOnboardingAttachment(id, attachmentId) {
    return axios.get(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/attachments/${attachmentId}/download`,
      {
        responseType: "blob",
      },
    );
  }

  // Client Onboarding – Notifications
  sendClientOnboardingNotification(id, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/notify`,
      data,
    );
  }

  getClientOnboardingNotifications(id) {
    return axios.get(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/notifications`,
    );
  }

  // Client Onboarding – Acknowledge
  acknowledgeClientOnboardingStep(id, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/acknowledge`,
      data,
    );
  }

  // Client Onboarding – Reject
  rejectClientOnboardingStep(id, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/reject`,
      data,
    );
  }

  // Client Onboarding – Email Logs
  getClientOnboardingEmailLogs(id) {
    return axios.get(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/email-logs`,
    );
  }

  addClientOnboardingEmailLog(id, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/email-logs`,
      data,
    );
  }

  // Client Onboarding – Timers
  startClientOnboardingTimer(id, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/timer/start`,
      data,
    );
  }

  stopClientOnboardingTimer(id, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/timer/stop`,
      data,
    );
  }

  // Client Onboarding – Internal Messages
  getClientOnboardingMessages(id) {
    return axios.get(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/messages`,
    );
  }

  sendClientOnboardingMessage(id, data) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/messages`,
      data,
    );
  }

  // Client Onboarding – Activity Timeline
  getClientOnboardingTimeline(id) {
    return axios.get(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/timeline`,
    );
  }

  // Client Onboarding – Contract Data Extraction
  extractContractData(id, formData) {
    return axios.post(
      `${this.jwtConfig.baseURL}client-onboarding/${id}/extract-contract`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  }

  // Client Onboarding – Packets
  getAvailablePackets() {
    return axios.get(`${this.jwtConfig.baseURL}client-onboarding/packets`);
  }

  //ftp group
}
